import React, { useEffect, useRef, useState } from "react";
import { InputUserAdmin } from "./DialogAddUserAdmin";
import { ActiveType } from "../../../../models/Login";
import useUpdateUserAdmin from "../hook/UpdateUserAdmin";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { UserFormServiceButtonClose, UserFormServiceButtonCreated } from "../../MyBooking/styled/DesStyled";
import { PHONE_COUNTRY_CODE } from "../../LoginUser/hook/phoneCountryCode";
import useOrderDetail from "../hook/useGetUserDetail";

export default function DialogUpdateUserAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	UserId: string;
	reload: () => void;
}) {
	const { userDetail } = useOrderDetail({ id: props.UserId, openDialog: props.openDialog });
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState(PHONE_COUNTRY_CODE[0].dial_code);
	const [type, setType] = useState("");
	const [pass, setPass] = useState("");
	const [rePass, setRePass] = useState("");
	const { updateUserAd } = useUpdateUserAdmin({ id: props.UserId, reload: props.reload });

	const handleSave = async () => {
		await updateUserAd(name, email, phone, pass, selectedCountryCode, type);
		props.setOpenDialog(false);
	};

	useEffect(() => {
		if (props.openDialog && userDetail) {
			setName(userDetail.fullName || "");
			setEmail(userDetail.email || "");
			setPhone(userDetail.phone || "");
			setSelectedCountryCode(userDetail.phonePrefix || "");
			setType(userDetail.communicationId || "0");
			setPass("");
		}
	}, [userDetail, props.openDialog]);

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Update User"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
				</>
			}>
			<InputUserAdmin
				name={name}
				setName={setName}
				email={email}
				setEmail={setEmail}
				phone={phone}
				setPhone={setPhone}
				selectedCountryCode={selectedCountryCode}
				setSelectedCountryCode={setSelectedCountryCode}
				type={type}
				setType={setType}
				pass={pass}
				setPass={setPass}
				rePass={rePass}
				setRePass={setRePass}
				update={true}
			/>
		</DialogWrapMedium>
	);
}
